import React from 'react';
import { Slider, SliderSingleProps } from 'antd';
import { CustomComponentProps } from '../types';

export interface MySliderProps extends CustomComponentProps {
  min?: number;
  max?: number;
  step?: number;
  marks?: Record<number, string | { style?: React.CSSProperties; label: string }>;
  vertical?: boolean;
  range?: boolean;
  tooltipVisible?: boolean;
  tooltipPlacement?: 'top' | 'left' | 'right' | 'bottom';
}

const MySlider: React.FC<MySliderProps> = ({
  value,
  onChange,
  disabled,
  readonly,
  min = 0,
  max = 100,
  step = 1,
  marks,
  vertical = false,
  range = false,
  tooltipVisible,
  tooltipPlacement = 'top',
  ...rest
}) => {
  const handleChange = (newValue: number | number[]) => {
    if (!readonly && onChange) {
      onChange(newValue);
    }
  };

  const sliderProps: SliderSingleProps = {
    value,
    onChange: handleChange,
    disabled: disabled || readonly,
    min,
    max,
    step,
    marks,
    vertical,
    tooltip: tooltipVisible !== false ? { placement: tooltipPlacement } : undefined,
    ...rest,
  };

  if (range) {
    return <Slider range {...(sliderProps as any)} />;
  }

  return <Slider {...sliderProps} />;
};

export default MySlider;
